module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "inbox"
  }, [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("Forms 组件")])]), _vm._v(" "), _c('breadcrumb', {
    attrs: {
      "data": _vm.$store.state.bcArray
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-66c06390!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/forms.vue
// module id = 321
// module chunks = 2